import { createActionsHook } from "react-redux-actions-hook";
import { TechnicalViewActionType } from "./constants";
import { api } from "api/common";
import { setToastMessage } from "components/app/actions";
import {
  ALL_AGRICULTURE_URL,
  GET_ALL_DISTRICT_WATER,
  GET_ALL_DELIVERIES,
  ALL_CITIES_URL,
  ALL_CITIES_WATER_USE,
  CITY_METRICS_URL,
  CITY_WATER_SOURCES_URL,
  CITY_POPULATION_URL,
  ENTITY_ENTITLMENTS_URL,
  ALL_CITY_METRICS_URL,
  ALL_TRIBES_URL,
  TRIBES_METRICS_URL,
  ENTITLMENTS_BY_YEAR_URL,
  ENTITLMENTS_RANGE_URL,
  PRIORITY_POOL_ENTITLMENTS_URL,
  // GET_CITIES_TOTAL_CO_ACCESS_URL,
  PER_PERSON_DIFFERENCE_ENTITY_ENTITLMENTS_URL,
  GET_INDUSTRY_METRICS,
  WESTERN_AZ_ENTITLMENTS_URL,
  WESTERN_AZ_ENTITIES_URL,
  WESTERN_AZ_PRIORITY_ENTITLMENTS_URL,
  WESTERN_AZ_ENTITY_ENTITLMENTS_URL,
  ALL_SCENARIOS_URL,
} from "api/constants";

export const setIsInitialMount = (value) => {
  return { type: TechnicalViewActionType.SET_IS_INITIAL_MOUNT, value };
};

export const toggleAboutDrawer = ({ isMobile }) => {
  if (isMobile) {
    return {
      type: TechnicalViewActionType.TOGGLE_ABOUT,
      toggle: false,
    };
  } else {
    return { type: TechnicalViewActionType.TOGGLE_ABOUT };
  }
};

export const toggleAboutDrawerHidden = () => {
  return { type: TechnicalViewActionType.TOGGLE_ABOUT_HIDDEN };
};

export const setChart = (chart) => {
  return { type: TechnicalViewActionType.SET_CHART, chart };
};

export const setScenario = (scenario) => {
  return { type: TechnicalViewActionType.SET_SCENARIO, scenario };
};

export const setScenarioSelected = (scenario) => {
  return { type: TechnicalViewActionType.SET_SCENARIO_SELECTED, scenario };
};

export const loadScenarios = () => {
  return (dispatch) => {
    api(`${ALL_SCENARIOS_URL}`, { method: 'GET' }, dispatch)
      .then((response) => {
        dispatch(listScenarios(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || 'Unable to fetch scenario',
            type: 'error',
          })
        );
      });
  };
};

export const listScenarios = (scenarios) => {
  // scenarios.forEach((scenario, index) => scenarios[index].image = imageDict[scenario.image]);
  return { type: TechnicalViewActionType.SET_ALL_SCENARIOS, scenarios };
};

export const setBigRiverPolicy = (big_river_policy) => {
  return {
    type: TechnicalViewActionType.SET_BIG_RIVER_POLICY,
    big_river_policy,
  };
};

export const resetSidebarAccordions = () => {
  return { type: TechnicalViewActionType.RESET_SIDEBAR_ACCORDIONS };
};

export const updateSidebarAccordions = (accordion) => {
  return {
    type: TechnicalViewActionType.UPDATE_SIDEBAR_ACCORDIONS,
    accordion,
  };
};

// COLORADO RIVER WATER ACCSESS
export const setAreaChartTab = (area_chart_tab) => {
  return { type: TechnicalViewActionType.SET_AREA_CHART_TAB, area_chart_tab };
};

// POLYGON MAP
export const setPolygonMapTab = (polygon_map_tab) => {
  return { type: TechnicalViewActionType.SET_POLYGON_MAP_TAB, polygon_map_tab };
};

// CENTRAL AZ WATER USES
export const setCentralAZTab = (central_az_tab) => {
  return { type: TechnicalViewActionType.SET_CENTRAL_AZ_TAB, central_az_tab };
};

// IRRIGATION (AGRICULTURE) DISTRICTS
export const resetSelectedAgriculture = () => {
  return { type: TechnicalViewActionType.RESET_SELECTED_AGRICULTURE };
};
export const listIrrigationDistricts = (irrigation_districts) => {
  return {
    type: TechnicalViewActionType.SET_ALL_IRRIGATION_DISTRICTS,
    irrigation_districts,
  };
};
export const loadIrrigationDistricts = () => {
  return (dispatch) => {
    api(`${ALL_AGRICULTURE_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listIrrigationDistricts(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setSelectedIrrigationDistrict = (district_selected) => {
  if (district_selected !== null) {
    return {
      type: TechnicalViewActionType.SET_SELECTED_IRRIGATION_DISTRICT,
      district_selected,
    };
  }
};

export const loadAgricultureDistrictWater = () => {
  return (dispatch) => {
    api(`${GET_ALL_DISTRICT_WATER}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listAgricultureDistrictWater(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listAgricultureDistrictWater = (district_water) => {
  return {
    type: TechnicalViewActionType.SET_DISTRICT_WATER,
    district_water,
  };
};

export const loadWaterDeliveries = () => {
  return (dispatch) => {
    api(`${GET_ALL_DELIVERIES}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listWaterDeliveries(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listWaterDeliveries = (deliveries) => {
  return {
    type: TechnicalViewActionType.SET_DELIVERIES,
    deliveries,
  };
};

// CITIES
export const setSelectedCity = (city_selected) => {
  if (city_selected !== undefined) {
    return {
      type: TechnicalViewActionType.SET_SELECTED_CITY,
      city_selected,
    };
  }
};

export const resetSelectedCity = () => {
  return { type: TechnicalViewActionType.RESET_SELECTED_CITY };
};

export const setPreviousMapSelection = (previousMapSelection) => {
  return { type: TechnicalViewActionType.SET_PREVIOUS_MAP_SELECTION, previousMapSelection };
};

export const listCities = (cities) => {
  return { type: TechnicalViewActionType.SET_ALL_CITIES, cities };
};
export const loadCities = () => {
  return (dispatch) => {
    api(`${ALL_CITIES_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listCities(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listCitiesPopulation = (population) => {
  return { type: TechnicalViewActionType.SET_CITY_POPULATION, population };
};
export const loadCitiesPopulation = () => {
  return (dispatch) => {
    api(`${CITY_POPULATION_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listCitiesPopulation(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listCityMetrics = (city_metrics) => {
  return { type: TechnicalViewActionType.SET_CITY_METRICS, city_metrics };
};

export const loadCityMetrics = (city_id) => {
  return (dispatch) => {
    api(
      `${CITY_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ city_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listCityMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

//Tribes
export const listTribes = (tribes) => {
  return { type: TechnicalViewActionType.SET_ALL_TRIBES, tribes };
};
export const loadTribes = () => {
  return (dispatch) => {
    api(`${ALL_TRIBES_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        response.data.rows.forEach((ele) => {
          ele.label = ele.label.replace("Reservation", "Indian Community");
          // console.log(ele);
        });
        // console.log(response.data.rows);
        dispatch(listTribes(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listTribeMetrics = (tribe_metrics) => {
  return { type: TechnicalViewActionType.SET_TRIBE_METRICS, tribe_metrics };
};

export const loadTribeMetrics = (tribe_id) => {
  return (dispatch) => {
    api(
      `${TRIBES_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ tribe_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listTribeMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch tribe metrics",
            type: "error",
          })
        );
      });
  };
};

export const setSelectedTribe = (tribe_selected) => {
  return { type: TechnicalViewActionType.SET_SELECTED_TRIBE, tribe_selected };
};

export const setEntityEntitlements = (entitlements) => {
  return {
    type: TechnicalViewActionType.SET_ENTITY_ENTITLEMENTS,
    entitlements,
  };
};

export const loadEntityEntitlements = (entity_id, scenario_id) => {
  return (dispatch) => {
    api(
      `${ENTITY_ENTITLMENTS_URL}`,
      { method: "POST", body: JSON.stringify({ entity_id, scenario_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(setEntityEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setAllCitiesMetric = (all_cities_metric) => {
  return {
    type: TechnicalViewActionType.SET_ALL_CITY_METRICS,
    all_cities_metric,
  };
};

export const loadAllCitiesMetric = () => {
  return (dispatch) => {
    api(`${ALL_CITY_METRICS_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(setAllCitiesMetric(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setPriorityEntitlements = (priority_entitlements) => {
  return {
    type: TechnicalViewActionType.SET_PRIORITY_ENTITLEMENTS,
    priority_entitlements,
  };
};

export const loadPriorityEntitlements = (scenario_id) => {
  return (dispatch) => {
    api(
      `${PRIORITY_POOL_ENTITLMENTS_URL}/${scenario_id}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        // console.log("=========loadPriorityEntitlements===========");
        // console.log(response.data.rows);
        dispatch(setPriorityEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setPerPersonEntitlementDifference = (entitlement_difference) => {
  return {
    type: TechnicalViewActionType.SET_PER_PERSON_ENTITLEMENT_DIFFERENCE,
    entitlement_difference,
  };
};

export const loadPerPersonEntitlementDifference = (scenario_id) => {
  return (dispatch) => {
    api(
      `${PER_PERSON_DIFFERENCE_ENTITY_ENTITLMENTS_URL}/${scenario_id}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        dispatch(setPerPersonEntitlementDifference(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch entitlement difference",
            type: "error",
          })
        );
      });
  };
};

export const listCityWaterSources = (city_water_sources) => {
  return {
    type: TechnicalViewActionType.SET_CITY_WATER_SOURCES,
    city_water_sources,
  };
};

export const loadCityWaterSources = (city_id) => {
  return (dispatch) => {
    api(
      `${CITY_WATER_SOURCES_URL}`,
      { method: "POST", body: JSON.stringify({ city_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listCityWaterSources(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listCitiesWaterUse = (cities_water_use) => {
  return {
    type: TechnicalViewActionType.SET_ALL_CITY_WATER_USE,
    cities_water_use,
  };
};
export const loadCitiesWaterUse = () => {
  return (dispatch) => {
    api(`${ALL_CITIES_WATER_USE}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listCitiesWaterUse(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

// INDUSTRY
export const loadIndustryMetrics = () => {
  return (dispatch) => {
    api(`${GET_INDUSTRY_METRICS}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listIndustryMetrics(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listIndustryMetrics = (industry_metrics) => {
  return {
    type: TechnicalViewActionType.SET_INDUSTRY_METRICS,
    industry_metrics,
  };
};

export const setIsTribe = (value) => {
  return { type: TechnicalViewActionType.SET_IS_TRIBE, value };
};

export const setIsCity = (value) => {
  return { type: TechnicalViewActionType.SET_IS_CITY, value };
};

export const setSelectedWesternArizonaEntity = (western_arizona_selected) => {
  return {
    type: TechnicalViewActionType.SET_WESTERN_ARIZONA_SELECTED,
    western_arizona_selected,
  };
};

export const setEntitlementYear = (year) => {
  return { type: TechnicalViewActionType.SET_ENTITLEMENT_YEAR, year };
};

export const setUserLastSelectedMapState = (mapState) => {
  return { type: TechnicalViewActionType.SET_USER_LAST_SELECTED_MAP_STATE, mapState };
};

export const setSliderEntitlementYear = (year) => {
  return { type: TechnicalViewActionType.SET_SLIDER_ENTITLEMENT_YEAR, year };
};

export const listEntitlementsByYear = (entitlements_by_year) => {
  return {
    type: TechnicalViewActionType.SET_ENTITLEMENTS_BY_YEAR,
    entitlements_by_year,
  };
};

export const loadEntitlementsByYear = (year, scenario_id) => {
  return (dispatch) => {
    api(
      `${ENTITLMENTS_BY_YEAR_URL}`,
      { method: "POST", body: JSON.stringify({ year, scenario_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listEntitlementsByYear(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listWesternArizonaEntitlements = (
  western_arizona_entitlements
) => {
  return {
    type: TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITLEMENTS,
    western_arizona_entitlements,
  };
};

export const loadWesternArizonaEntitlements = (scenario_id) => {
  return (dispatch) => {
    api(`${WESTERN_AZ_ENTITLMENTS_URL}/${scenario_id}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listWesternArizonaEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listWesternArizonaPriorityEntitlements = (
  western_priority_entitlements
) => {
  return {
    type: TechnicalViewActionType.SET_WESTERN_ARIZONA_PRIORITY_ENTITLEMENTS,
    western_priority_entitlements,
  };
};

export const loadWesternArizonaPriorityEntitlements = (scenario_id) => {
  return (dispatch) => {
    api(`${WESTERN_AZ_PRIORITY_ENTITLMENTS_URL}/${scenario_id}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listWesternArizonaPriorityEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setWesternArizonaEntityEntitlements = (western_entity_entitlements) => {
  return {
    type: TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITY_ENTITLEMENTS,
    western_entity_entitlements,
  };
};

export const loadWesternArizonaEntityEntitlements = (entity_id, scenario_id) => {
  return (dispatch) => {
    api(
      `${WESTERN_AZ_ENTITY_ENTITLMENTS_URL}`,
      { method: "POST", body: JSON.stringify({ entity_id, scenario_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(setWesternArizonaEntityEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listAccessDifferenceRange = (access_difference_range) => {
  return {
    type: TechnicalViewActionType.SET_ENTITLEMENTS_BY_YEAR_RANGE,
    access_difference_range,
  };
};

export const loadAccessDifferenceRange = (scenario_id) => {
  return (dispatch) => {
    api(
      `${ENTITLMENTS_RANGE_URL}`,
      { method: "POST", body: JSON.stringify({ scenario_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listAccessDifferenceRange(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setSelectedCityGauge = (city_selected_gauge) => {
  if (city_selected_gauge !== undefined) {
    return {
      type: TechnicalViewActionType.SET_SELECTED_CITY_GAUGE,
      city_selected_gauge,
    };
  }
};

export const resetSelectedCityGauge = () => {
  return { type: TechnicalViewActionType.RESET_SELECTED_CITY_GAUGE };
};

export const listCityMetricsGauge = (city_metrics_gauge) => {
  return {
    type: TechnicalViewActionType.SET_CITY_METRICS_GAUGE,
    city_metrics_gauge,
  };
};

export const loadCityMetricsGauge = (city_id) => {
  return (dispatch) => {
    api(
      `${CITY_METRICS_URL}`,
      { method: "POST", body: JSON.stringify({ city_id }) },
      dispatch
    )
      .then((response) => {
        dispatch(listCityMetricsGauge(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const listWesternArizonaEntities = (western_arizona_entities) => {
  return {
    type: TechnicalViewActionType.SET_WESTERN_ARIZONA_ENTITIES,
    western_arizona_entities,
  };
};

export const setIsWesternEntity = (is_western) => {
  return {
    type: TechnicalViewActionType.SET_IS_WESTERN,
    is_western,
  };
};

export const loadWesternArizonaEntities = () => {
  return (dispatch) => {
    api(`${WESTERN_AZ_ENTITIES_URL}`, { method: "GET" }, dispatch)
      .then((response) => {
        dispatch(listWesternArizonaEntities(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const setSliderRange = (data) => {
  return {
    type: TechnicalViewActionType.CHANGE_SLIDER_RANGE,
    data,
  };
}

export const setMapZoom = (mapZoom) => {
  return {
    type: TechnicalViewActionType.SET_MAP_ZOOM,
    mapZoom,
  };
};

export const setEntityHeader = (data, id) => {
  return {
    type: TechnicalViewActionType.SET_ENTITY_HEADER,
    id,
    data,
  }
}

export default createActionsHook({
  setIsInitialMount,
  toggleAboutDrawer,
  toggleAboutDrawerHidden,
  setChart,
  setScenario,
  setScenarioSelected,
  loadScenarios,
  resetSidebarAccordions,
  updateSidebarAccordions,
  //POLYGON MAP
  setPolygonMapTab,
  // COLORADO RIVER WATER ACCSESS
  setAreaChartTab,
  // CENTRAL AZ WATER USES
  setCentralAZTab,
  // IRRIGATION (AGRICULTURE) DISTRICTS
  resetSelectedAgriculture,
  loadIrrigationDistricts,
  setSelectedIrrigationDistrict,
  loadAgricultureDistrictWater,
  loadWaterDeliveries,
  // CITIES
  setIsCity,
  setSelectedCity,
  resetSelectedCity,
  setPreviousMapSelection,
  loadCities,
  loadCityMetrics,
  loadCityWaterSources,
  loadCitiesWaterUse,
  setBigRiverPolicy,
  listCitiesPopulation,
  loadCitiesPopulation,
  // CITIES GAUGE CHART
  setSelectedCityGauge,
  resetSelectedCityGauge,
  loadCityMetricsGauge,
  // TRIBES
  loadTribes,
  setSelectedTribe,
  loadTribeMetrics,
  setIsTribe,
  // INDUSTRY
  loadIndustryMetrics,
  // CO RIVER ACCESS ENTITLEMENTS
  loadEntityEntitlements,
  setAllCitiesMetric,
  loadAllCitiesMetric,
  setEntitlementYear,
  setUserLastSelectedMapState,
  setSliderEntitlementYear,
  loadEntitlementsByYear,
  loadAccessDifferenceRange,
  loadPriorityEntitlements,
  loadPerPersonEntitlementDifference,
  // WESTERN AZ
  listWesternArizonaEntitlements,
  loadWesternArizonaEntitlements,
  listWesternArizonaEntities,
  loadWesternArizonaEntities,
  listWesternArizonaPriorityEntitlements,
  loadWesternArizonaPriorityEntitlements,
  loadWesternArizonaEntityEntitlements,
  setSelectedWesternArizonaEntity,
  setIsWesternEntity,
  setSliderRange,
  setMapZoom,
  setEntityHeader,
});
